import { Component, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';

export interface ISessionCardData {
	start_time: string;
	end_time: string;
	time_interval: string;
	month: string;
	day: number | string;
	year: number | string;
	location_title: string;
	location?: string;
	timezone: string;
	seats_available: number;
	isWebinar: boolean;
	class?: ISessionCardState;
}

export enum ISessionCardState {
	DEFAULT = '--default'
}

@Component({
	selector: 'angie-session-details-card',
	templateUrl: './session-details-card.component.html',
	styleUrls: ['./session-details-card.component.scss']
})
export class SessionDetailsCardComponent extends BaseComponent {
	@Input() sessionData: Partial<ISessionCardData>;
}
